import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Modal } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import {
    showValueStreamLoader,
    onSaveValueStream,
    onValueStreamClose,
} from 'actions/valueStream';
import { inputFields, displayedImage, showErrors, modalHeader, isFormValid, getFormError } from '../common';

const ValueStreamAdd = () => {
    const dispatch = useDispatch();
    const addValueStreamState = useSelector(state => state.valueStreams.addValueStreamState);
    const portfolios = useSelector(state => state.portfolios.allPortfolio);
    const [selectedValueStream, setSelectedValueStream] = useState(initProps);
    const [formErrors, setFormErrors] = useState({ name: '', budget: '' });
    const [formValid, setFormValid] = useState(false);

    useEffect(() => {
        setSelectedValueStream(initProps());
    }, [addValueStreamState]);

    // using selectedValueStream makes it behave like componentDidUpdate - effect takes place when selectedValueStream changes
    useEffect(() => {
        setFormValid(false);
        validateForm();
    }, [selectedValueStream]);

    const initProps = () => {
        return {
            id: '',
            orgid: '',
            name: '',
            description: '',
            teams: [],
            valueProposition: '',
            budget: 0,
            kpi: '',
            systems: '',
            owner: '',
            theme: '',
            starred: false,
            frequently: false,
        };
    };

    const handleUserInput = (event, isNumber) => {
        const name = event.target.name;
        let value = event.target.value;
        if (isNumber) {
            value = Number(event.target.value);
        }
        updateSelectedValueStreamField(name, value);
        validateField(name, value);
    };

    const updateSelectedValueStreamField = (fieldName, value) => {
        const newValueStream = { ...selectedValueStream };
        newValueStream[fieldName] = value;
        setSelectedValueStream(newValueStream);
    };

    const validateField = (fieldName, value) => {
        formErrors[fieldName] = getFormError(fieldName, value);
        setFormErrors(formErrors);
        validateForm();
    };

    const validateForm = () => {
        setFormValid(isFormValid(selectedValueStream));
    };

    const maintainButton = (label) => {
        return (
            <Button className="text-uppercase" disabled={!formValid} color="primary" onClick={() => {
                dispatch(showValueStreamLoader());
                dispatch(onValueStreamClose());
                dispatch(onSaveValueStream(selectedValueStream));
                setSelectedValueStream(initProps());
                setFormValid(false);
            }}>
                {label}
            </Button>
        );
    };

    const modalHeaderOnClick = () => {
        return () => {
            setFormValid(false);
            dispatch(onValueStreamClose());
        };
    };

    const modalBody = (buttonText) => {
        return (
            <Fragment>
                <div className="modal-box-content">
                    <div className="row no-gutters">
                        {displayedImage(selectedValueStream)}
                        {showErrors(formErrors)}
                        {inputFields(selectedValueStream, portfolios, handleUserInput)}
                    </div>
                </div>

                <div className="modal-box-footer d-flex flex-row">
                    {maintainButton(buttonText)}
                </div>
            </Fragment>
        );
    };

    return (
        <Modal className="modal-box" isOpen={addValueStreamState}>
            {modalHeader(<IntlMessages id="valueStream.addValueStream" />, modalHeaderOnClick)}
            {modalBody(<IntlMessages id="valueStream.addValueStream" />)}
        </Modal>
    );
};

export default ValueStreamAdd;


// WEBPACK FOOTER //
// ./components/Agile/valueStream/valueStreamMaintenance/valueStreamAdd/index.js